import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { BusinessVerificationApiError } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { BusinessVerificationApiErrorsService } from 'src/app/services/business-verification-api-errors.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-business-verification-errors-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './business-verification-api-errors-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BusinessVerificationApiErrorsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private BusinessVerificationApiErrorService: BusinessVerificationApiErrorsService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'BusinessVerificationApiError';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.BusinessVerificationApiErrorService.getBusinessVerificationErrors(
            queryObject
          ),
          this.BusinessVerificationApiErrorService.getBusinessVerificationErrorCount(
            countQueryObject
          )
        ]).subscribe({
          next: ([
            BusinessVerificationApiErrors,
            businessVerificationApiErrorCount
          ]: [BusinessVerificationApiError[], number]) => {
            const successObject: { rowData: any[]; rowCount: number } = {
              rowData: BusinessVerificationApiErrors,
              rowCount: businessVerificationApiErrorCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
